import {
  CheckoutSessionPayload,
  CheckoutSessionResponse,
  OnboardingStatus,
  UpgradeAgreementPayload,
  UpgradeAgreementResponse,
} from "@/schema/onboarding"

import { ApiContext, apiContextFetch } from "@/hooks/api/base"

export function fetchOnboardingStatus(context: ApiContext) {
  return apiContextFetch<OnboardingStatus>(context, "onboarding")
}

export function claimAccount(context: ApiContext) {
  return apiContextFetch<void>(context, "claim_account", {
    method: "POST",
  })
}

export function createCheckoutSession(context: ApiContext, data: CheckoutSessionPayload) {
  return apiContextFetch<CheckoutSessionResponse>(context, "onboarding_checkout_sessions", {
    method: "POST",
    body: JSON.stringify({ checkout_session: data }),
  })
}

export function createUpgradeAgreement(context: ApiContext, data: UpgradeAgreementPayload) {
  return apiContextFetch<UpgradeAgreementResponse>(context, "onboarding_upgrade_agreements", {
    method: "POST",
    body: JSON.stringify({ solo_upgrade_agreement: data }),
  })
}

export function completeOnboarding(context: ApiContext) {
  return apiContextFetch<OnboardingStatus>(context, "onboarding", {
    method: "PATCH",
  })
}

export function setPendingPageportUpdate(context: ApiContext) {
  return apiContextFetch<OnboardingStatus>(context, "onboarding/pending_pageport_update", {
    method: "POST",
  })
}

export interface CrmMigrationRequestPayload {
  current_crm: string
  other_crm_name?: string
  estimated_contacts: string
  usage_duration: string
}

export function submitCrmMigrationRequest(context: ApiContext, data: CrmMigrationRequestPayload) {
  return apiContextFetch<void>(context, "onboarding/submit_crm_migration_request", {
    method: "POST",
    body: JSON.stringify({ crm_migration_request: data }),
  })
}
